import { Col, Form, Input, message, Modal, Row } from "antd";
import { Rule } from "antd/lib/form";
import { staffApi } from "api/staff.api";
import { SingleImageUpload } from "components/Upload/SingleImageUpload";
import React, { useCallback, useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { Staff } from "types/staff";

export const UploadImageModal = ({
  visible,
  onClose,
  onSubmitOk,
}: {
  visible: boolean;
  onClose: () => void;
  onSubmitOk: (imagePath: string) => void;
}) => {
  const [image, setImage] = useState("");

  useEffect(() => {
    if (visible) {
      setImage("");
    }
  }, [visible]);

  const handleUploadImageOk = useCallback((path: string) => {
    console.log("onUploadOk:", path);
    setImage((prev) => path);
  }, []);

  return (
    (<Modal
      onCancel={onClose}
      open={visible}
      title={"Upload ảnh"}
      style={{ top: 20 }}
      width={700}
      onOk={() => {
        onSubmitOk(image);
      }}
    >
      <SingleImageUpload onUploadOk={handleUploadImageOk} imageUrl={image} />
    </Modal>)
  );
};
